// Records which CTA sent someone to the contact form, so a submission arrives
// saying where it came from.
//
// sessionStorage rather than component state or context because the click and
// the submit don't always happen on the same page: the CTAs on /founder
// navigate home before the form is ever mounted, which unmounts everything
// holding in-memory state along the way.
const STORAGE_KEY = 'candlelyte:lead-source';

function setLeadSource(source) {
    if (!source) return;

    try {
        window.sessionStorage.setItem(STORAGE_KEY, source);
    } catch {
        // private browsing or storage disabled — attribution is a nice-to-have
        // and is never worth breaking a CTA over
    }
}

function getLeadSource() {
    try {
        // someone can also reach the form by scrolling past every CTA, or by
        // landing on /#contact directly from a link
        return window.sessionStorage.getItem(STORAGE_KEY) || 'None — reached the form directly';
    } catch {
        return 'Unknown — storage unavailable';
    }
}

export { setLeadSource, getLeadSource };
